import { EventEmitter, Input, OnDestroy, Output, TemplateRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ISession } from '../../models/session';
import { ITag } from '../../models/tag';
import { assoc } from 'ramda/es';

import { CustomizationService } from '../customization/customization.service';
import { RenderTags } from '../customization/tags.pipe';
import { TagsService } from '../sessions/tags.service';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'image-or-iframe',
  templateUrl: './image-or-iframe.component.html',
  styleUrls: ['./image-or-iframe.component.scss']
})
export class ImageOrIframeComponent implements OnInit, OnDestroy {
  @Input() tag: ITag;
  @Input('session') session: ISession;
  @Input() completions;

  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  public previewHash;
  public imagePreviewUrl: string = '';
  public iframeValue: string = '';
  public updateIframe$: Subject<string> = new Subject();
  public modalRef: BsModalRef;

  private imageTag: ITag = {
    name: 'webevent.global.beforelivecontent.image',
    description: 'webevent.global.beforelivecontent.image',
    type: 'image',
    value: ''
  };
  private iframeTag: ITag = {
    name: 'webevent.global.beforelivecontent.iframe',
    description: 'webevent.global.beforelivecontent.iframe',
    type: 'text',
    value: ''
  };

  constructor(
    private customizationService: CustomizationService,
    private tagsService: TagsService,
    private renderTags: RenderTags,
    private translateService: TranslateService,
    private modalService: BsModalService
  ) {}

  ngOnDestroy(): void {}

  ngOnInit() {
    if (this.value !== 'image' && this.value !== 'iframe') {
      this.value = 'image';
    }

    this.updateIframe$
      .debounceTime(2000)
      .distinctUntilChanged()
      .subscribe(value => {
        this.updateIFrameTag(assoc('value', value, this.iframeTag));
      });
    this.previewHash = new Date().getTime();

    this.tagsService.getTag(this.session, `${this.tag.name}.image`).subscribe(tags => {
      this.imagePreviewUrl = tags[0]
        ? this.renderTags.transform(this.disableCaching(tags[0].value), this.completions)
        : '';
    });

    this.tagsService.getTag(this.session, `${this.tag.name}.iframe`).subscribe(tags => {
      this.iframeValue = tags[0] ? tags[0].value : '';
    });
  }

  openModal(template: TemplateRef<any>, tag: ITag) {
    this.modalRef = this.modalService.show(template, { class: 'inmodal' });
  }

  importImage({ name, data }) {
    this.customizationService
      .uploadImage(this.session, assoc('value', { name, data }, this.imageTag), data)
      .subscribe(
        tag => {
          this.imagePreviewUrl = tag.value;
          this.valueChange.emit(this.value);
          this.previewHash = new Date().getTime();
        },
        error => {
          if (error.status === 413) {
            return toastr.error(this.translateService.instant('action.imageBig'));
          }
          toastr.error(this.translateService.instant('action.failed'));
        }
      );
  }

  public valueChanged($event) {
    this.valueChange.emit(this.value);
  }

  public removeImage() {
    this.customizationService.removeImage(this.session, this.imageTag, false).subscribe(
      () => {
        this.imagePreviewUrl = '';
        const value = this.iframeValue ? 'iframe' : 'none';
        this.valueChange.emit(value);
      },
      err => {
        toastr.error(this.translateService.instant('action.failed'));
      }
    );
  }

  updateIframeContent() {
    this.updateIframe$.next(this.iframeValue);
  }

  disableCaching(data: string) {
    if (!data) return data;
    const disableCache = 'no_cache=' + this.previewHash;
    const separator = data.indexOf('?') === -1 ? '?' : '&';
    return data.concat(separator, disableCache);
  }

  updateIFrameTag(tag: ITag) {
    this.customizationService.updateTags(this.session, [tag]).subscribe(
      () => {
        if (!this.iframeValue) {
          const value = this.imagePreviewUrl ? 'image' : 'none';
          this.valueChange.emit(value);
        } else {
          this.valueChange.emit(this.value);
        }
        this.previewHash = new Date().getTime();
      },
      () => {
        toastr.error(this.translateService.instant('action.failed'));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/image-or-iframe/image-or-iframe.component.ts